

import { createHelpers } from 'vuex-map-fields';

const { getFiltroLicenciaField, updateFiltroLicenciaField } = createHelpers({
  getterType: 'getFiltroLicenciaField',
  mutationType: 'updateFiltroLicenciaField',
});

export default {
  namespaced: true,
  state: {
    SearchTerm: '',
    Personal: null,
    Personal_Id: null,
    FechaDesde: null,
    FechaHasta: null,
    CantidadDias: 0,
    Fecha: null,
    FiltroEstablecimiento: {
      selected: 0,
      opciones:[
        { value: 0, text: "--Seleccionar--" },
        { value: 1, text: "Nivel" },
        { value: 2, text: "Unidad Educativa" },
        { value: 3, text: "SAED" }
      ]
    },
    SolicitudSeleccionada:null,
    SolicitudSeleccionada_Id: 0,
    CIE10:null,
    CIE10_Id: 0,
    TipoLicencia_Id: 0,
    DetalleDiasLicencia_Id: 0,
    TipoLicencia: null,
    DetalleDiasLicencia: null,
    Observaciones: ''
  },
  mutations: {
    updateFiltroLicenciaField,
  },
  getters: {
    getFiltroLicenciaField,
  }
};



// WEBPACK FOOTER //
// ./src/store/filtrolicencia.js